export default function getCasinoGameUrl(game) {
  const category = game.category || 'slots'
  return {
    pathname: `/casino/${category}/${game.provider}/${game.id}/${game.key}`.toLowerCase(),
    search: '?referrer=casino',
  }
}
